import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';

/**
 * A raw "modulo" item as returned by the backend.
 */
export interface ModuloDTO {
  id: number;
  nome: string;
}

@Injectable()
export class ListaModuliService {
  private readonly endpoint = `${environment.baseUrl}v1/modulo`;
  private http = inject(HttpClient);

  fetchGetAllModuli(): Observable<ModuloDTO[]> {
    return this.http.get<ModuloDTO[]>(this.endpoint);
  }

  fetchModuliByIdStrutturaPadre(
    idStrutturaPadre: number
  ): Observable<ModuloDTO[]> {
    return this.http.get<ModuloDTO[]>(
      `${environment.baseUrl}v1/findModuliByidStrutturaPadre/${idStrutturaPadre}`
    );
  }
}
